import { render, staticRenderFns } from "./ViewInfoCard.vue?vue&type=template&id=48cf0d34&"
import script from "./ViewInfoCard.vue?vue&type=script&lang=js&"
export * from "./ViewInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./ViewInfoCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports